import React, { useState, useEffect } from "react";
import Footer from "components/footer/Footer";
import SectionThree from "components/sectionThree/SectionThree";

import HalfArrow from "assets/images/half-arrow.svg";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "redux-store/store";
import {
  errorCleanUp,
  forgotPassword,
  messageCleanUp,
} from "redux-store/auth/auth.slice";
import {
  error,
  loginSuccessMessage,
  activityInProcess,
} from "redux-store/auth/auth.selector";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const loading = useSelector(activityInProcess);
  const [formData, setFormData] = useState({
    email: "",
  });
  const [errMessages, setMessages] = useState({
    emailMessage: "",
  });
  const signInError = useSelector(error);
  const succesMessage = useSelector(loginSuccessMessage);
  useEffect(() => {
    dispatch(errorCleanUp());
    dispatch(messageCleanUp());
    if (succesMessage !== "") {
      let path = "forgot";
      navigate(`/auth/enter-otp/${formData.email}/${path}`);
    }
  }, [succesMessage]);

  const onchange = (e: { target: { name: any; value: any } }) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email: string) => {
    // Regular expression pattern for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const onSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    const { email } = formData;
    let validEmail = true;

    if (!validateEmail(email)) {
      validEmail = false;
    }
    setMessages({
      ...errMessages,
      emailMessage: validEmail ? "" : "Invalid Email",
    });
    if (validEmail) {
      dispatch(errorCleanUp());
      if (succesMessage !== "") {
        dispatch(messageCleanUp());
      }
      dispatch(forgotPassword(formData));
    }
  };
  return (
    <div className="tw-w-full">
      {/* 1st main div */}
      <div className="tw-w-full">
        <SectionThree>
          <div className="tw-w-[80%] tw-mx-auto tw-bg-white tw-py-6 tw-shadow-small tw-rounded-[1.9375rem] lg:tw-w-[40%] lg:tw-rounded-[1.25rem] lg:tw-shadow-large">
            <div className="tw-w-[90%] tw-mx-auto tw-flex tw-flex-col tw-space-y-3 tw-py-4 lg:tw-w-[70%] ">
              <div>
                <span className="tw-flex-1 tw-text-[1.625rem] tw-text-black tw-font-bold lg:tw-text-[2.25rem] ">
                  Forgot your password?
                </span>
              </div>
              <div>
                <form>
                  <div className="tw-flex tw-flex-col tw-space-y-2">
                    <label className="tw-text-[0.75rem] tw-text-black tw-font-light lg:tw-text-base lg:tw-font-normal">
                      Enter email Address
                    </label>

                    <input
                      type="email"
                      className="tw-rounded tw-p-2 tw-text-[0.625rem] tw-bg-[#FFF6F4] focus:tw-outline-none tw-text-black lg:tw-text-sm"
                      placeholder="Enter email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => onchange(e)}
                    />
                    <span className=" tw-text-xs tw-text-red-500">
                      {errMessages.emailMessage}
                    </span>
                  </div>
                </form>
              </div>
              <div className="tw-flex tw-items-center tw-justify-center">
                <div className="tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-2">
                  <span className="tw-text-xs tw-text-red-500">
                    {signInError.message !== "" ? signInError.message : ""}
                  </span>
                  <button
                    className="tw-flex tw-items-center tw-space-x-1.5 tw-mt-[0.25rem] tw-py-1 tw-px-2 tw-rounded-full tw-bg-[#FF7B6D] tw-text-white tw-text-base"
                    onClick={(e) => {
                      onSubmit(e);
                    }}
                  >
                    <span className="tw-uppercase">Send Code</span>
                    <img src={HalfArrow} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </SectionThree>
      </div>

      {/* 2nd main div */}
      <div className="tw-flex">
        <Footer />
      </div>
    </div>
  );
};

export default ForgotPassword;
